import { Component } from "@/components/Vendo-view/lineChartLists";
import * as React from "react";
// import GridDemo from "../../../components/Vendo-view/lineChartLists";
// import DemoLine from "../../../components/Vendo-view/lineChartLists";
// import { Button } from "@/components/ui/button";

// import Navbar from "../../components/Layout/Navbar";
// import Sidebar from "../../components/Layout/Sidebar";
import { BsTicket } from "react-icons/bs";
import { MdOutlineLightbulb } from "react-icons/md";
import { RiListIndefinite } from "react-icons/ri";

const VendorDashboard: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-[#1A2035]">
      {/* Sidebar */}
      {/* <Sidebar /> */}

      {/* Main Content */}
      <div className="flex-1 bg-[#212941] p-6">
        {/* <Navbar /> */}
        <div className="mt-6">
          <h1 className="text-3xl font-bold text-white">Welcome, Vendor!</h1>
          <p className="text-white mt-2">
            Here’s an overview of your recent activities and analytics.
          </p>

          {/* Stats Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
            <div className="bg-[#31CE36] p-6 rounded-lg shadow">
              <div className="flex justify-between">
                <div>
                  <RiListIndefinite className="w-16 h-16 text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-medium text-white">Listing</h3>
                  <p className="text-2xl font-bold text-white mt-2">124</p>
                </div>
              </div>
            </div>
            <div className="bg-[#6960CE] p-6 rounded-lg shadow">
              <div className="flex justify-between">
                <div>
                  <BsTicket className="w-16 h-16 text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-medium text-white">
                    Support Teckets
                  </h3>
                  <p className="text-2xl font-bold text-white mt-2">$5,320</p>
                </div>
              </div>
            </div>
            <div className="bg-[#48ABF7] p-6 rounded-lg shadow">
              <div className="flex justify-between">
                <div>
                  <MdOutlineLightbulb className="w-16 h-16 text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-medium text-white">
                    Subscription Log
                  </h3>
                  <p className="text-2xl font-bold text-white mt-2">8</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
        <div className="bg-[#212941]">
          <h1 className="text-white mx-6 mt-5 ">
            Monthly Listing Posts (2025)
          </h1>
          <Component />
        </div>
        <div className="bg-[#212941]">
          <h1 className="text-white mx-6 mt-5 ">Monthly Visitors (2025)</h1>
          <Component />
        </div>
      </div>
    </div>
  );
};

export default VendorDashboard;
